/**
 * Created by Jie Gao on 05/24/2019.
 */

import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DragonTribeGameAssets} from "../DragonTribeGameAssets";
import {DTReelSymbol} from "./DTReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";

export class DTReelSymbolH extends DTReelSymbol {

    private _multiplier:PIXI.Sprite;
    private _eggEffect:TimelineSprite;
    private _eggHit:TimelineSprite;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected initAnimations():void {
        super.initAnimations();
        if(!this._multiplier) {
            this._multiplier = this.createEmptySprite("");
            this._multiplier.anchor.set(0.5, 0.5);
            this._multiplier.y = -390;
        }

        if(!this._eggEffect) {
            this._eggEffect = new TimelineSprite(GameResources.getTextures("eggEffect"));
            this._eggEffect.anchor.set(0.5, 0.5);
            this._eggEffect.position.set(0, 0);
            this._eggEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
            this._eggEffect.hide();
        }

        if(!this._eggHit) {
            this._eggHit = new TimelineSprite(GameResources.getTextures("eggHit"));
            this._eggHit.anchor.set(0.5, 0.5);
            this._eggHit.position.set(0, 0);
            this._eggHit.blendMode = PIXI.BLEND_MODES.SCREEN;
        }
    }

    public updateBackground(symHeight:number,callFromAS:boolean=false):void {
        super.updateBackground(symHeight,callFromAS);
        const isScattter:boolean = this.symName.indexOf("S") > -1;
        const texture:string = (isScattter ? DragonTribeGameAssets.S_BG : DragonTribeGameAssets.W_BG);
        this._symBackground.texture = GameResources.getTextures(texture)[0];
        this._symTop.texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_T : DragonTribeGameAssets.W_T)[0];
        this._symBottom.texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_B : DragonTribeGameAssets.W_B)[0];
        this._symSides.texture = GameResources.getTextures(isScattter ? DragonTribeGameAssets.S_S : DragonTribeGameAssets.W_S)[0];
    }

    public patchMultiplier(texture:string):void {
        this._multiplier.y = -(454 - this.symHeight / 2);
        this._multiplier.texture = GameResources.getTextures(texture)[0];
        this.addChild(this._multiplier);
        this._multiplier.visible = true;
    }

    public playEggEffect():void {
        this.addChild(this._eggEffect);
        this._eggEffect.show();
        this._eggEffect.playLoop();
    }

    public playEggHit():TimelineLite {
        this.addChild(this._eggHit);
        this._eggHit.alpha = 1;
        const tl:TimelineLite = new TimelineLite().add([
            () => {
                this._eggEffect.stopLoop();
                this._eggEffect.hide();
                this.removeChild(this._eggEffect);
            },
            TweenLite.to(this, 1, {alpha : 0}),
            this._eggHit.getAnimationAutoShowHide(true, true)
        ]);
        tl.timeScale(2);
        return tl;
    }

    public onRemove():void {
        if(this._multiplier) {
            this.removeChild(this._multiplier);
        }

        if(this._eggEffect) {
            this._eggEffect.stopLoop();
            this._eggEffect.hide();
            this.removeChild(this._eggEffect);
        }

        if(this._eggHit) {
            this._eggHit.stopLoop();
            this._eggHit.hide();
            this.removeChild(this._eggHit);
        }
        super.onRemove();
    }

    protected drawSymMask():boolean {
        if(this.symHeight < 255) {
            this._symMask = new PIXI.Graphics();
            this._symMask.beginFill(0xFF0000, 1);
            this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH + 20, this.symHeight);
            this.addChild(this._symMask);
            this._symBackground.mask = this._symMask;
            this._symSides.mask = this._symMask;
            return true;
        }
        return false;
    }
}